// extracted by mini-css-extract-plugin
module.exports = {"root":"Chip_root__1ZBaz","selected":"Chip_selected__9ACFF"};